import YearlyCreditsWarningBar from "./YearlyCreditsWarningBar";

export default YearlyCreditsWarningBar;
